import { Button, Form, IFormRender, IFormValidation, Label, TextFormField } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { useRef } from 'react';
import { t } from 'utils/localize';

export interface ISingleFieldFormProps {
  title: string;
  initialValue?: string;
  subtitle?: string;
  onSubmit: (value: string) => void;
  validations?: Array<IFormValidation<string>>;
  className?: ClassName;
}

interface IFormData {
  key: string;
}

const SingleFieldForm = ({
  title,
  subtitle,
  initialValue,
  validations,
  className,
  onSubmit,
}: ISingleFieldFormProps) => {
  const formData = useRef({ key: initialValue ?? '' });

  function renderFormFields(form: IFormRender<any>) {
    return (
      <>
        <Label secondaryLabel={subtitle}>{title}</Label>
        <TextFormField name="key" form={form} validations={validations} autofocus={true} />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  function onSubmitForm(newFormData: IFormData) {
    onSubmit(newFormData.key);
  }

  const classes = classNames('single-field-form', className);

  return <Form render={renderFormFields} onSubmit={onSubmitForm} className={classes} data={formData.current} />;
};

export default SingleFieldForm;
